// Ryff Scale question text and example content used by the assessment and admin detail view.
export const ryffQuestions = [
    // Q1 - Autonomy (NORMAL SCORING)
    {
      id: 1,
      dimension: 'autonomy',
      text: 'I am not afraid to voice my opinions, even when they are in opposition to the opinions of most people.',
      reverse: false,
      examples: [
        "Speaking up in class even when your view is different",
        "Expressing your true thoughts in group discussions",
        "Standing by your beliefs despite peer pressure"
      ],
      examplesFil: [
        "Pagsasalita sa klase kahit iba ang opinion mo",
        "Pagpapahayag ng tunay na iniisip sa group discussion",
        "Pagtayo sa inyong paniniwala kahit may peer pressure"
      ]
    },
    // Q2 - Personal Growth (NORMAL SCORING)
    {
      id: 2,
      dimension: 'personal_growth',
      text: 'For me, life has been a continuous process of learning, changing, and growth.',
      reverse: false,
      examples: [
        "Always looking for ways to improve yourself",
        "Learning new skills or hobbies regularly",
        "Reflecting on experiences to grow as a person"
      ],
      examplesFil: [
        "Palaging naghahanap ng paraan para mag-improve",
        "Regular na pag-aaral ng mga bagong skills o hobbies",
        "Pag-reflect sa mga experience para lumaki bilang tao"
      ]
    },
    // Q3 - Environmental Mastery (REVERSE-SCORED)
    {
      id: 3,
      dimension: 'environmental_mastery',
      text: 'In general, I feel I am in charge of the situation in which I live.',
      reverse: true,
      examples: [
        "Feeling like you control your daily schedule",
        "Managing your responsibilities effectively",
        "Making decisions that shape your life"
      ],
      examplesFil: [
        "Pakiramdam na kontrolado mo ang daily schedule mo",
        "Effective na pag-manage ng mga responsibilidad",
        "Paggawa ng mga desisyon na nag-shape sa buhay mo"
      ]
    },
    // Q4 - Positive Relations (NORMAL SCORING)
    {
      id: 4,
      dimension: 'positive_relations',
      text: 'People would describe me as a giving person, willing to share my time with others.',
      reverse: false,
      examples: [
        "Volunteering to help friends with their problems",
        "Spending time listening to others when they need support",
        "Being generous with your time and attention"
      ],
      examplesFil: [
        "Volunteer na tumulong sa mga problema ng kaibigan",
        "Paglaan ng oras para makinig sa iba kapag kailangan nila",
        "Pagiging generous sa oras at attention"
      ]
    },
    // Q5 - Personal Growth (REVERSE-SCORED)
    {
      id: 5,
      dimension: 'personal_growth',
      text: 'I am not interested in activities that will expand my horizons.',
      reverse: true,
      examples: [
        "Avoiding new experiences or challenges",
        "Sticking to familiar routines and activities",
        "Not wanting to try things outside your comfort zone"
      ],
      examplesFil: [
        "Pag-iwas sa mga bagong experience o challenges",
        "Pagtayo sa pamilyar na routine at activities",
        "Ayaw subukan ang mga bagay na labas sa comfort zone"
      ]
    },
    // Q6 - Purpose in Life (NORMAL SCORING)
    {
      id: 6,
      dimension: 'purpose_in_life',
      text: 'I enjoy making plans for the future and working to make them a reality.',
      reverse: false,
      examples: [
        "Setting goals for your career or education",
        "Making detailed plans for achieving your dreams",
        "Working step-by-step toward long-term objectives"
      ],
      examplesFil: [
        "Pagset ng mga goals para sa career o education",
        "Paggawa ng detalyadong plano para sa mga pangarap",
        "Step-by-step na pagtrabaho tungo sa long-term objectives"
      ]
    },
    // Q7 - Positive Relations (NORMAL SCORING)
    {
      id: 7,
      dimension: 'positive_relations',
      text: 'Most people see me as loving and affectionate.',
      reverse: false,
      examples: [
        "Being known for giving warm hugs",
        "Friends describing you as caring and kind",
        "Showing affection through words and actions"
      ],
      examplesFil: [
        "Kilala sa pagbibigay ng warm hugs",
        "Mga kaibigan na nagsasabing caring at kind ka",
        "Pagpapakita ng pagmamahal sa salita at gawa"
      ]
    },
    // Q8 - Self-Acceptance (REVERSE-SCORED)
    {
      id: 8,
      dimension: 'self_acceptance',
      text: 'In many ways I feel disappointed about my achievements in life.',
      reverse: true,
      examples: [
        "Feeling like you haven't accomplished enough",
        "Comparing yourself negatively to others' success",
        "Wishing you had achieved more by now"
      ],
      examplesFil: [
        "Pakiramdam na hindi ka pa sapat na nag-accomplish",
        "Negative na pagcompare sa success ng iba",
        "Sana mas marami ka nang na-achieve ngayon"
      ]
    },
    // Q9 - Purpose in Life (NORMAL SCORING)
    {
      id: 9,
      dimension: 'purpose_in_life',
      text: 'I live life one day at a time and don\'t really think about the future.',
      reverse: false,
      examples: [
        "Focusing only on today without planning ahead",
        "Not setting long-term goals or objectives",
        "Taking life as it comes without direction"
      ],
      examplesFil: [
        "Focus lang sa ngayon hindi nag-plaplano sa hinaharap",
        "Walang long-term goals o objectives",
        "Tinatanggap lang ang buhay kung ano man ang dumating"
      ]
    },
    // Q10 - Autonomy (REVERSE-SCORED)
    {
      id: 10,
      dimension: 'autonomy',
      text: 'I tend to worry about what other people think of me.',
      reverse: true,
      examples: [
        "Constantly wondering if others approve of your choices",
        "Changing your behavior based on others' opinions",
        "Feeling anxious about how you're perceived"
      ],
      examplesFil: [
        "Palaging nag-iisip kung approve ba ang iba sa choices mo",
        "Pagbabago ng behavior base sa opinion ng iba",
        "Kinakabahan sa kung paano ka nakikita ng iba"
      ]
    },
    // Q11 - Self-Acceptance (NORMAL SCORING)
    {
      id: 11,
      dimension: 'self_acceptance',
      text: 'When I look at the story of my life, I am pleased with how things have turned out.',
      reverse: false,
      examples: [
        "Feeling satisfied with your life journey so far",
        "Being proud of the choices you've made",
        "Accepting both your successes and failures"
      ],
      examplesFil: [
        "Satisfied sa life journey mo so far",
        "Proud sa mga choices na ginawa mo",
        "Pagtanggap sa success at failures mo"
      ]
    },
    // Q12 - Environmental Mastery (NORMAL SCORING)
    {
      id: 12,
      dimension: 'environmental_mastery',
      text: 'I have difficulty arranging my life in a way that is satisfying to me.',
      reverse: false,
      examples: [
        "Struggling to organize your daily routine",
        "Finding it hard to balance work and personal life",
        "Feeling like your life lacks structure or order"
      ],
      examplesFil: [
        "Hirap mag-organize ng daily routine",
        "Mahirap i-balance ang work at personal life",
        "Pakiramdam na walang structure o order ang buhay"
      ]
    },
    // Q13 - Autonomy (REVERSE-SCORED)
    {
      id: 13,
      dimension: 'autonomy',
      text: 'My decisions are not usually influenced by what everyone else is doing.',
      reverse: true
    },
    // Q14 - Personal Growth (REVERSE-SCORED)
    {
      id: 14,
      dimension: 'personal_growth',
      text: 'I gave up trying to make big improvements or changes in my life a long time ago.',
      reverse: true
    },
    // Q15 - Environmental Mastery (REVERSE-SCORED)
    {
      id: 15,
      dimension: 'environmental_mastery',
      text: 'The demands of everyday life often get me down.',
      reverse: true
    },
    // Q16 - Positive Relations (REVERSE-SCORED)
    {
      id: 16,
      dimension: 'positive_relations',
      text: 'I have not experienced many warm and trusting relationships with others.',
      reverse: true
    },
    // Q17 - Personal Growth (REVERSE-SCORED)
    {
      id: 17,
      dimension: 'personal_growth',
      text: 'I think it is important to have new experiences that challenge how you think about yourself and the world.',
      reverse: true
    },
    // Q18 - Positive Relations (REVERSE-SCORED)
    {
      id: 18,
      dimension: 'positive_relations',
      text: 'Maintaining close relationships has been difficult and frustrating for me.',
      reverse: true
    },
    // Q19 - Self-Acceptance (REVERSE-SCORED)
    {
      id: 19,
      dimension: 'self_acceptance',
      text: 'My attitude about myself is probably not as positive as most people feel about themselves.',
      reverse: true
    },
    // Q20 - Purpose in Life (NORMAL SCORING)
    {
      id: 20,
      dimension: 'purpose_in_life',
      text: 'I have a sense of direction and purpose in life.',
      reverse: false
    },
    // Q21 - Autonomy (NORMAL SCORING)
    {
      id: 21,
      dimension: 'autonomy',
      text: 'I judge myself by what I think is important, not by the values of what others think is important.',
      reverse: false
    },
    // Q22 - Self-Acceptance (NORMAL SCORING)
    {
      id: 22,
      dimension: 'self_acceptance',
      text: 'In general, I feel confident and positive about myself.',
      reverse: false
    },
    // Q23 - Environmental Mastery (REVERSE-SCORED)
    {
      id: 23,
      dimension: 'environmental_mastery',
      text: 'I have been able to build a living environment and a lifestyle for myself that is much to my liking.',
      reverse: true
    },
    // Q24 - Autonomy (NORMAL SCORING)
    {
      id: 24,
      dimension: 'autonomy',
      text: 'I tend to be influenced by people with strong opinions.',
      reverse: false
    },
    // Q25 - Personal Growth (NORMAL SCORING)
    {
      id: 25,
      dimension: 'personal_growth',
      text: 'I do not enjoy being in new situations that require me to change my old familiar ways of doing things.',
      reverse: false
    },
    // Q26 - Environmental Mastery (REVERSE-SCORED)
    {
      id: 26,
      dimension: 'environmental_mastery',
      text: 'I do not fit very well with the people and the community around me.',
      reverse: true
    },
    // Q27 - Positive Relations (REVERSE-SCORED)
    {
      id: 27,
      dimension: 'positive_relations',
      text: 'I know that I can trust my friends, and they know they can trust me.',
      reverse: true
    },
    // Q28 - Personal Growth (NORMAL SCORING)
    {
      id: 28,
      dimension: 'personal_growth',
      text: 'When I think about it, I haven\'t really improved much as a person over the years.',
      reverse: false
    },
    // Q29 - Purpose in Life (NORMAL SCORING)
    {
      id: 29,
      dimension: 'purpose_in_life',
      text: 'Some people wander aimlessly through life, but I am not one of them.',
      reverse: false
    },
    // Q30 - Positive Relations (REVERSE-SCORED)
    {
      id: 30,
      dimension: 'positive_relations',
      text: 'I often feel lonely because I have few close friends with whom to share my concerns.',
      reverse: true
    },
    // Q31 - Self-Acceptance (REVERSE-SCORED)
    {
      id: 31,
      dimension: 'self_acceptance',
      text: 'When I compare myself to friends and acquaintances, it makes me feel good about who I am.',
      reverse: true
    },
    // Q32 - Purpose in Life (REVERSE-SCORED)
    {
      id: 32,
      dimension: 'purpose_in_life',
      text: 'I don\'t have a good sense of what it is I\'m trying to accomplish in life.',
      reverse: true
    },
    // Q33 - Purpose in Life (NORMAL SCORING)
    {
      id: 33,
      dimension: 'purpose_in_life',
      text: 'I sometimes feel as if I\'ve done all there is to do in life.',
      reverse: false
    },
    // Q34 - Self-Acceptance (REVERSE-SCORED)
    {
      id: 34,
      dimension: 'self_acceptance',
      text: 'I feel like many of the people I know have gotten more out of life than I have.',
      reverse: true
    },
    // Q35 - Autonomy (NORMAL SCORING)
    {
      id: 35,
      dimension: 'autonomy',
      text: 'I have confidence in my opinions, even if they are contrary to the general consensus.',
      reverse: false
    },
    // Q36 - Environmental Mastery (REVERSE-SCORED)
    {
      id: 36,
      dimension: 'environmental_mastery',
      text: 'I am quite good at managing the many responsibilities of my daily life.',
      reverse: true
    },
    // Q37 - Personal Growth (NORMAL SCORING)
    {
      id: 37,
      dimension: 'personal_growth',
      text: 'I have the sense that I have developed a lot as a person over time.',
      reverse: false
    },
    // Q38 - Positive Relations (NORMAL SCORING)
    {
      id: 38,
      dimension: 'positive_relations',
      text: 'I enjoy personal and mutual conversations with family members and friends.',
      reverse: false
    },
    // Q39 - Purpose in Life (REVERSE-SCORED)
    {
      id: 39,
      dimension: 'purpose_in_life',
      text: 'My daily activities often seem trivial and unimportant to me.',
      reverse: true
    },
    // Q40 - Self-Acceptance (NORMAL SCORING)
    {
      id: 40,
      dimension: 'self_acceptance',
      text: 'I like most parts of my personality.',
      reverse: false
    },
    // Q41 - Autonomy (REVERSE-SCORED)
    {
      id: 41,
      dimension: 'autonomy',
      text: 'It\'s difficult for me to voice my own opinions on controversial matters.',
      reverse: true
    },
    // Q42 - Environmental Mastery (NORMAL SCORING)
    {
      id: 42,
      dimension: 'environmental_mastery',
      text: 'I often feel overwhelmed by my responsibilities.',
      reverse: false
    }
  ];
